// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as React from "react";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as Primitive_float from "@rescript/runtime/lib/es6/Primitive_float.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query taxes($filterBy: InputTaxQueryFilter)  {\ntaxes(first: 50, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nvalue  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.taxes;
  let value$2 = value$1.edges;
  return {
    taxes: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            value: value$1.value,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.taxes;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.value;
    let value$6 = value$1.id;
    let value$7 = value$1.__typename;
    let node = {
      __typename: value$7,
      id: value$6,
      value: value$5,
      shop: shop
    };
    let value$8 = value.__typename;
    return {
      __typename: value$8,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let taxes = {
    __typename: value$3,
    edges: edges
  };
  return {
    taxes: taxes
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputTaxQueryFilter(inp) {
  let a = inp.archived;
  let a$1 = inp.shopIds;
  return {
    archived: a !== undefined ? (
        a === "ONLY" ? "ONLY" : (
            a === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    shopIds: a$1 !== undefined ? serializeInputObjectInFilter(a$1) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputTaxQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputTaxQueryFilter(archived, shopIds, param) {
  return {
    archived: archived,
    shopIds: shopIds
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputTaxQueryFilter: serializeInputObjectInputTaxQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputTaxQueryFilter: makeInputObjectInputTaxQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputTaxQueryFilter: serializeInputObjectInputTaxQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputTaxQueryFilter: makeInputObjectInputTaxQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function CatalogProductTaxSelect(props) {
  let onChange = props.onChange;
  let defaultTaxValue = props.defaultTaxValue;
  let value = props.value;
  let activeShop = Auth.useActiveShop();
  let queryResults = use(undefined, undefined, undefined, undefined, "NetworkOnly", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    filterBy: {
      archived: "EXCLUDED",
      shopIds: {
        _in: [Stdlib_Option.mapOr(activeShop, "", param => param.id)]
      }
    }
  });
  let match = queryResults.data;
  let options = match !== undefined ? Stdlib_Array.filterMap(match.taxes.edges, param => {
      let tax = param.node;
      let uuid = Uuid.fromString(tax.id);
      if (uuid !== undefined) {
        return {
          id: Primitive_option.valFromOption(uuid),
          value: tax.value
        };
      }
    }).toSorted((current, next) => Primitive_float.compare(current.value, next.value)) : [];
  React.useEffect(() => {
    if (Stdlib_Option.isNone(value)) {
      let defaultTaxValue$1 = Stdlib_Option.getOr(defaultTaxValue, Math.max(...options.map(tax => tax.value)));
      let taxFromQueryOptions = options.find(tax => tax.value === defaultTaxValue$1);
      let match = options[0];
      if (taxFromQueryOptions !== undefined) {
        onChange(taxFromQueryOptions);
      } else if (match !== undefined) {
        onChange(match);
      }
    }
  }, [queryResults.data]);
  let items = options.map(tax => ({
    TAG: "Option",
    key: tax.id,
    label: tax.value.toFixed(2).replace(".", ",") + " %",
    value: tax
  }));
  let sections = [{
      items: items
    }];
  let onSelectionChange = selection => {
    if (selection.TAG !== "Single") {
      return;
    }
    let tax = selection._0;
    if (tax !== undefined) {
      return onChange(tax);
    }
  };
  let match$1 = queryResults.error;
  let errorMessage = match$1 !== undefined ? I18n.t("Unable to load VAT rates, your session may have expired. Please reload the page.") : undefined;
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("VAT"),
    placeholder: queryResults.loading ? I18n.t("Loading...") : I18n.t("Select a tax value"),
    preset: {
      NAME: "inputField",
      VAL: {
        required: true,
        errorMessage: errorMessage
      }
    },
    searchable: false,
    disabled: Stdlib_Option.isNone(value),
    sections: sections,
    value: {
      TAG: "Single",
      _0: value
    },
    onChange: onSelectionChange
  });
}

let make = React.memo(CatalogProductTaxSelect);

export {
  Query,
  make,
}
/* query Not a pure module */
